"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const List_1 = tslib_1.__importDefault(require("@mui/material/List"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const styles_1 = require("@mui/material/styles");
const RailItem_1 = tslib_1.__importDefault(require("./RailItem"));
const RailMenuButton_1 = tslib_1.__importDefault(require("./RailMenuButton"));
const ListItemRail = (0, styles_1.styled)(ListItem_1.default)({ padding: 0 });
const Rail = (props) => {
    const { onMenuButtonClick, items, MenuButtonProps, ...restProps } = props;
    const paperProps = {
        ...restProps,
        square: true,
        variant: "outlined",
        sx: theme => ({
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            minWidth: `calc(${theme.spacing(8)} + 1px)`,
            width: `calc(${theme.spacing(8)} + 1px)`,
            border: 0,
            borderRight: `1px solid ${theme.palette.divider}`,
        }),
    };
    const menuButtonProps = {
        onClick: onMenuButtonClick,
        ...MenuButtonProps,
    };
    return (react_1.default.createElement(Paper_1.default, { ...paperProps, component: "nav" },
        react_1.default.createElement(List_1.default, { disablePadding: true },
            react_1.default.createElement(ListItemRail, { dense: true, disableGutters: true },
                react_1.default.createElement(RailMenuButton_1.default, { ...menuButtonProps })),
            items.map((item) => (react_1.default.createElement(ListItemRail, { dense: true, disableGutters: true, key: item.text },
                react_1.default.createElement(RailItem_1.default, { key: item.text, ...item })))))));
};
exports.default = Rail;
